import { render, staticRenderFns } from "./EmptyImage.vue?vue&type=template&id=2a5c56bf&"
import script from "./EmptyImage.vue?vue&type=script&lang=ts&"
export * from "./EmptyImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports